import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { event } from "jquery";
// gsap.registerPlugin(ScrollTrigger);

// Original Version

// if ($(".wp-block-group:has(.post-slider)").length) {

//     gsap.config({
//         ease: 'none', // Best for scrubbing
//         force3D: true, // GPU acceleration
//     });

//     gsap.registerPlugin(ScrollTrigger);

//     let sections = gsap.utils.toArray(".feature-item");
//     const wrapper = document.querySelector("wp-block-group:has(.post-slider) .post-slider-items > .acf-innerblocks-container");
//     const totalWidth = sections.reduce((acc, curr) => acc + curr.clientWidth, 0);

//     const tl = gsap.timeline({
//         scrollTrigger: {
//             trigger: ".wp-block-group:has(.post-slider)",
//             pin: true,
//             pinSpacing: true,
//             // anticipatePin: 1,
//             scrub: 1,
//             snap: 1 / (sections.length - 1),
//             invalidateOnRefresh: true,
//             end: () => "+=" + document.querySelector(".post-slider").offsetWidth
//             // end: () => "+=" + (document.querySelector(".post-slider").offsetWidth - 300)
//         }
//     });

//     tl.to(sections, {
//         // x: () => -100 * (sections.length - 1),
//         xPercent: -100 * (sections.length - 1),
//         ease: "ease-in-out",
//     });

//     //disable tl on mobile
//     if ($(window).width() < 768) {
//         tl.scrollTrigger.disable();
//         gsap.set(sections, { x: 0 }); // reset the position of the sections
//     } else {
//         tl.scrollTrigger.enable();
//         tl.scrollTrigger.refresh();
//         gsap.set(sections, { x: 0 }); // reset the position of the sections
//     }

//     window.addEventListener("resize", () => {
//         if ($(window).width() < 768) {
//             tl.scrollTrigger.disable();
//             gsap.set(sections, { x: 0 }); // reset the position of the sections
//         } else {
//             tl.scrollTrigger.enable();
//             tl.scrollTrigger.refresh();
//             gsap.set(sections, { x: 0 }); // reset the position of the sections
//         }
//     });

// }

// Improved Version Start

if ($(".wp-block-group:has(.post-slider)").length) {
    // Configure GSAP for smooth, hardware-accelerated animations without easing
    gsap.config({
        ease: 'none',
        force3D: true,
    });

    // Register the ScrollTrigger plugin, required for scroll-driven animations
    gsap.registerPlugin(ScrollTrigger);

    // Get all the slide sections as an array
    let sections = gsap.utils.toArray(".feature-item");

    // Get the container that wraps the slides
    const wrapper = document.querySelector(".wp-block-group:has(.post-slider) .post-slider-items > .acf-innerblocks-container");

    // Calculate the width of one slide (assuming all slides have the same width)
    let slideWidth = sections[0]?.clientWidth || 0;

    // The slider container element
    const slider = document.querySelector(".post-slider");

    // GSAP timeline variable (to be initialized in initSlider)
    let tl;

    // Number of slides before the end where we want to stop the scroll animation
    const stopSlides = 2;

    // Initialize or re-initialize the slider animation and ScrollTrigger
    function initSlider() {
        // Only run if there are slides and screen width is >= 768px (desktop breakpoint)
        if (sections.length && window.innerWidth >= 768) {
            // Calculate the total scrollable distance in pixels,
            // stopping 'stopSlides' slides before the last one
            // We subtract 1 more because array index starts at 0
            const stopPosition = (sections.length - 1 - stopSlides) * slideWidth;

            // Calculate the max scroll distance allowed for the pin animation
            // (width of the slider minus one slide width for visual padding)
            const maxScrollDistance = slider.offsetWidth - slideWidth;

            // If timeline exists from previous init, kill it to avoid duplicates or bugs
            if (tl) {
                tl.kill();
                if (tl.scrollTrigger) tl.scrollTrigger.kill();
            }

            // Create new GSAP timeline with ScrollTrigger controlling the scroll-driven animation
            tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".wp-block-group:has(.post-slider)", // The element that triggers the scroll effect
                    pin: true,              // Pin this section during scroll
                    pinSpacing: true,       // Add space for pinned element to avoid jump
                    scrub: 1.5,               // Smoothly scrubs animation to scroll progress
                    snap: 1 / (sections.length - stopSlides), // Snap animation to each slide
                    invalidateOnRefresh: true, // Recalculate on resize or refresh
                    end: () => `+=${maxScrollDistance}` // End scroll animation after maxScrollDistance px
                }
            });

            // Animate the x position of all slides horizontally, moving left (negative x)
            // but only up to the calculated stopPosition (2 slides before the end)
            tl.to(sections, {
                x: -stopPosition,   // Move slides left by stopPosition pixels
                ease: "none",       // Linear easing (no easing) for scroll scrub effect
                onUpdate: function() {
                    // Optional hook if you want to add behaviors near the end of the animation
                    if (this.progress() >= 0.95) {
                        // For example, could add a fade out or stop interaction here
                    }
                }
            });
        } else {
            // For smaller screen sizes or no slides, reset all slides to zero x offset
            gsap.set(sections, { x: 0 });
        }
    }

    // Initial setup: create timeline and ScrollTrigger
    initSlider();

    // Listen for window resize, debounce to avoid excessive calls
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Refresh slide list and slideWidth on resize (in case layout changed)
            sections = gsap.utils.toArray(".feature-item");
            slideWidth = sections[0]?.clientWidth || 0;

            // Reinitialize timeline and ScrollTrigger with updated values
            initSlider();
        }, 100);
    });
}

// Improved Version End

// if ($(".wp-block-group:has(.post-slider)").length) {

//     let allowScroll = true; // sometimes we want to ignore scroll-related stuff, like when an Observer-based section is transitioning.
//     let scrollTimeout = $(window).width() < 768 ? gsap.delayedCall(1, () => allowScroll = true).pause() : gsap.delayedCall(.25, () => allowScroll = true).pause(); // controls how long we should wait after an Observer-based animation is initiated before we allow another scroll-related action
//     let currentIndex = 0;
//     let totalScroll = 0;
//     let swipePanels = gsap.utils.toArray(".wp-block-group:has(.post-slider) .feature-item");

//     $(".wp-block-group:has(.post-slider) .post-slider-items >.acf-innerblocks-container").css({
//         width: (swipePanels.length * $(swipePanels[0]).outerWidth()) + ((swipePanels.length - 1) * parseInt($(".wp-block-group:has(.post-slider) .post-slider-items >.acf-innerblocks-container").css("gap"))) + "px",
//     });

//     let intentObserver = null;

//     if ($(window).width() < 768) {
//         // create an observer and disable it to start
//         intentObserver = ScrollTrigger.observe({
//             type: "wheel,touch",
//             onDrag: (self) => {
//                 console.log("onDrag", self);
//                 // if the user is dragging, we want to disable the scroll observer
//                 if (self.isDragging) {
//                     allowScroll = false;
//                     scrollTimeout.restart(true);
//                 }
//                 //determine if the user is dragging left or right
//                 let direction = self.deltaX > 0 ? "right" : "left";
//                 if (direction === "right") {
//                     // if the user is dragging right, we want to go to the next panel
//                     gotoPanel(currentIndex + 1, true, self.event);
//                 } else {
//                     // if the user is dragging left, we want to go to the previous panel
//                     gotoPanel(currentIndex - 1, false, self.event);
//                 }
//                 console.log("direction", direction);
//                 return;
//             },
//             tolerance: 1,
//             preventDefault: false
//         });

//     } else {
//         intentObserver = ScrollTrigger.observe({
//             type: "wheel,touch",
//             onUp: () => allowScroll && gotoPanel(currentIndex - 1, false),
//             onDown: () => allowScroll && gotoPanel(currentIndex + 1, true),
//             tolerance: 5,
//             preventDefault: true,
//             onEnable(self) {
//                 allowScroll = false;
//                 scrollTimeout.restart(true);
//                 // when enabling, we should save the scroll position and freeze it. This fixes momentum-scroll on Macs, for example.
//                 let savedScroll = self.scrollY();
//                 self._restoreScroll = () => self.scrollY(savedScroll); // if the native scroll repositions, force it back to where it should be
//                 document.addEventListener("scroll", self._restoreScroll, {passive: false});
//             },
//             onDisable: self => document.removeEventListener("scroll", self._restoreScroll)
//         });
//     }

//     // handle the panel swipe animations
//     function gotoPanel(index, isScrollingDown, event) {

//         if ($(window).width() < 768) {
//             //check if we have clicked inside the swipe panels
//             let swipePanelsWrapper = gsap.utils.toArray(".wp-block-group:has(.post-slider) .post-slider");

//             let allowSwipe = false;
//             try {
//                 allowSwipe = $(swipePanelsWrapper).has(event.target).length;
//             } catch (e) {
//                 allowSwipe = false;
//             }

//             console.log("allowSwipe", allowSwipe);

//             if (!allowSwipe) {
//                 return;
//             }
//         }

//         // if ($(window).width() >= 768) {

//             // return to normal scroll if we're at the end or back up to the start
//             if ((index === swipePanels.length && isScrollingDown) && $(window).width() >= 768 || (index === -1 && !isScrollingDown) && $(window).width() >= 768 ) {
//                 intentObserver.disable(); // resume native scroll
//                 return;
//             }
//             allowScroll = false;
//             scrollTimeout.restart(true);

//             let target = gsap.utils.toArray(".wp-block-group:has(.post-slider) .post-slider-items >.acf-innerblocks-container");
//             let targetWidth = $(target[0]).outerWidth();
//             let currentPanel = swipePanels[currentIndex];
//             let currentPanelWidth = $(currentPanel).outerWidth();
//             let gap = parseInt($(target[0]).css("gap"));
//             let travelAmount = (index * currentPanelWidth) + (index * gap);
//             let travelAmountPercent = ((travelAmount / $(target[0]).outerWidth()) * 100) * -1;
//             if (isScrollingDown) {
//                 totalScroll += (parseFloat(currentPanelWidth) + parseFloat(gap));
//             } else {
//                 totalScroll -= (parseFloat(currentPanelWidth) + parseFloat(gap));
//             }

//             //detect how many panels are in the viewport
//             let panelsInView = Math.floor($(".wp-block-group:has(.post-slider) .post-slider-items").outerWidth() / currentPanelWidth);

//             //based on the current panels in view, we need to calculate the extra gap to determine if this number is correct
//             let extraGap = (panelsInView - 1) * gap;
//             //if we add the extra gap to the current panels in view, if this is greater than $(".wp-block-group:has(.post-slider) .post-slider-items").outerWidth() we need to minus 1 from the panels in view
//             if ((panelsInView * currentPanelWidth) + extraGap > $(".wp-block-group:has(.post-slider) .post-slider-items").outerWidth()) {
//                 panelsInView = panelsInView - 1;
//             }

//             if (index + panelsInView > swipePanels.length && $(window).width() >= 768) {
//                 intentObserver.disable();
//             } else {
//                 gsap.to(target, {
//                     xPercent: travelAmountPercent,
//                     duration: 0.5
//                 });
//                 currentIndex = index;
//             }
            
//         // }
        
//     }

//     let intent_is_mobile = false;

//     if ($(window).width() < 768) {
//         intentObserver.enable();
//         intent_is_mobile = true;
//     } else {
//         intentObserver.disable();
//         intent_is_mobile = false;
//     }

//     //handle window resize
//     $(window).on("resize", function () {

//         if ($(window).width() >= 768) {

//             let target = gsap.utils.toArray(".wp-block-group:has(.post-slider) .post-slider-items >.acf-innerblocks-container");
//             let targetWidth = $(target[0]).outerWidth();
//             let currentPanel = swipePanels[currentIndex];
//             let currentPanelWidth = $(currentPanel).outerWidth();

//             let panelsInView = Math.floor($(".wp-block-group:has(.post-slider) .post-slider-items").outerWidth() / currentPanelWidth);

//             if (currentIndex + panelsInView > swipePanels.length) {
//                 currentIndex = swipePanels.length - panelsInView;
//             }

//             let gap = parseInt($(target[0]).css("gap"));
//             let travelAmount = (currentIndex * currentPanelWidth) + (currentIndex * gap);
//             let travelAmountPercent = ((travelAmount / $(target[0]).outerWidth()) * 100) * -1;
//             gsap.set(target, {
//                 xPercent: travelAmountPercent
//             });
//         }
//     });

//     // pin swipe section and initiate observer
//     ScrollTrigger.create({
//         trigger: ".wp-block-group:has(.post-slider)",
//         pin: false,
//         pinSpacing: false,
//         start: "top",
//         end: "+=1", // just needs to be enough to not risk vibration where a user's fast-scroll shoots way past the end
//         onEnter: (self) => {
//             if (intentObserver.isEnabled || $(window).width() < 768) { return } // in case the native scroll jumped past the end and then we force it back to where it should be.
//             self.scroll(self.start + 1); // jump to just one pixel past the start of this section so we can hold there.
//             intentObserver.enable(); // STOP native scrolling
//         },
//         onEnterBack: (self) => {
//             if (intentObserver.isEnabled || $(window).width() < 768) { return } // in case the native scroll jumped backward past the start and then we force it back to where it should be.
//             self.scroll(self.end - 1); // jump to one pixel before the end of this section so we can hold there.
//             intentObserver.enable(); // STOP native scrolling
//         }
//     });

// }